import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {authOrgAPI, orgAPI} from '@/core/api';
//types
import {
  ICreateOrganizationRequest,
  IOrganization,
  IOrganizationLoginRequest,
  IOrganizationResponse,
  IOrganizationChangeProfileRequest,
  IOrganizationChangeProfileResponse,
  IGoogleOrganizationRegisterRequest,
  IAppleOrganizationRegisterRequest,
  IAppleSignupSession,
  IOrganizationPresignedUrls,
  IOrganizationSignUpResponse,
  ITeamData,
  IForgotPasswordRequest,
  IAuthAppleRequest,
  IAuthGoogleRequest,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationService {
  static create = async (reqBody: ICreateOrganizationRequest): Promise<AxiosResponse<IOrganizationSignUpResponse>> =>
    authOrgAPI.post(API_URL.ORGANIZATION_CREATE, reqBody);

  static googleRegister = async (
    reqBody: IGoogleOrganizationRegisterRequest
  ): Promise<AxiosResponse<IOrganizationSignUpResponse>> =>
    authOrgAPI.post(API_URL.GOOGLE_ORGANIZATION_REGISTER, reqBody);

  static login = async (reqBody: IOrganizationLoginRequest): Promise<AxiosResponse<IOrganizationResponse>> =>
    authOrgAPI.post(API_URL.ORGANIZATION_LOGIN, reqBody);

  static prepareAppleSignup = async (reqBody: IAuthAppleRequest): Promise<AxiosResponse<IAppleSignupSession>> =>
    authOrgAPI.post(API_URL.APPLE_ORGANIZATION_SIGNUP_PREPARE, reqBody);

  static appleRegister = async (
    reqBody: IAppleOrganizationRegisterRequest
  ): Promise<AxiosResponse<IOrganizationSignUpResponse>> =>
    authOrgAPI.post(API_URL.APPLE_ORGANIZATION_REGISTER, reqBody);

  static changeProfile = async (
    reqBody: IOrganizationChangeProfileRequest
  ): Promise<AxiosResponse<IOrganizationChangeProfileResponse>> => {
    return orgAPI.put(`${API_URL.ORGANIZATION_INFO}/${reqBody.id}`, reqBody);
  };

  static presignOrganizationAvatar = async (
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationPresignedUrls>> => {
    return apiInstance.get(API_URL.ORGANIZATION_PRESIGN_AVATAR);
  };

  static getTeamMemberInfo = async (id: number): Promise<AxiosResponse<ITeamData>> =>
    orgAPI.get(`${API_URL.TEAM}/${id}/member`);

  static deleteOrganization = async (id: number): Promise<AxiosResponse> =>
    orgAPI.delete(`${API_URL.ORGANIZATION_INFO}/${id}`);

  static forgotPassword = async (reqBody: IForgotPasswordRequest, apiInstance: AxiosInstance): Promise<AxiosResponse> =>
    apiInstance.post(API_URL.FORGOT_PASSWORD, reqBody);

  static googleAuth = async (reqBody: IAuthGoogleRequest): Promise<AxiosResponse<IOrganizationResponse>> =>
    authOrgAPI.post(API_URL.GOOGLE_LOGIN, reqBody);

  static appleAuth = async (reqBody: IAuthAppleRequest): Promise<AxiosResponse<IOrganizationResponse>> =>
    authOrgAPI.post(API_URL.APPLE_LOGIN, reqBody);

  static getOrganizationInfo = async (id: number): Promise<AxiosResponse<IOrganization>> =>
    orgAPI.get(`${API_URL.ORGANIZATION_INFO}/${id}`);
}

export {OrganizationService};
